import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import UnitConfigurationHeaders from "./UnitConfigurationHeaders";
import Establishments from "./Establishments/Establishments";


const EstablishmentConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <Establishments/>,
      
      
    ];
  
    return (
      <div className="page-content">
        <UnitConfigurationHeaders />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default EstablishmentConfiguration